import React from 'react'
import { WifiOff, RefreshCw } from 'lucide-react'
import Button from '../ui/Button'

type ConnectionErrorStateProps = {
  onRetry?: () => void
  title?: string
  description?: string
}

export const ConnectionErrorState: React.FC<ConnectionErrorStateProps> = ({
  onRetry,
  title = "Unable to load data",
  description = "There was a problem connecting to the server. Please check your connection and try again."
}) => {
  return (
    <div className="p-6 text-center">
      <div className="w-[180px] h-[120px] mx-auto my-2 mb-4 border border-dashed border-[#FECACA] rounded-lg bg-[#FEF2F2] flex items-center justify-center">
        <WifiOff className="w-12 h-12 text-[#DC2626]" strokeWidth={1.5} />
      </div>
      <div className="text-[#333] text-lg font-semibold">{title}</div>
      <div className="mt-2 text-[#666] max-w-[520px] mx-auto">
        {description}
      </div>
      {onRetry && (
        <div className="mt-4">
          <Button size="md" variant="primary" onClick={onRetry}>
            <RefreshCw className="w-4 h-4 mr-2" />
            Try Again
          </Button>
        </div>
      )}
    </div>
  )
}

